import { useEffect, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';

import useUserIdentity from 'hooks/useUserIdentity';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Divider from '@mui/material/Divider';
import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionSummary from '@mui/joy/AccordionSummary';
import AccordionGroup from '@mui/joy/AccordionGroup';

import { getIcon, pluralize } from 'utils/misc';

// import { FileAssociationType } from 'stores/file_association_store';
import useFileAssociation from 'hooks/useFileAssociation';
import FileItem from 'components/FileItem';

const CollabWorkSpaceSidebarFiles = observer(( { type, type_uuid }:
{type: string, type_uuid: string}) => {

    const { fetchListByAssociation, getListByAssociation, items } = useFileAssociation();
    const { currentIdentity } = useUserIdentity();
    const [loaded, setLoaded] = useState(false);
    const [fileAssociations, setFileAssociations] = useState(getListByAssociation(type, type_uuid));
    const AttachIcon = getIcon('AttachFile');

    const loader = useCallback(() => {
        if(type_uuid && currentIdentity.uuid) {
            setLoaded(true);
            fetchListByAssociation(currentIdentity.uuid, type, type_uuid).then((f) => {
                setFileAssociations(f);
            });
        }
    }, [fetchListByAssociation, type, type_uuid, currentIdentity.uuid, setLoaded]);

    useEffect(() => {
        setFileAssociations(getListByAssociation(type, type_uuid));
    }, [getListByAssociation, type, type_uuid, currentIdentity.uuid]);

    useEffect(() => {
        setFileAssociations(getListByAssociation(type, type_uuid));
    }, [items.length, getListByAssociation, type, type_uuid]);

    useEffect(() => {
        if(!loaded) {
            loader();
        }
    }, [loader, loaded, setLoaded]);

    return (
        <AccordionGroup size="lg">
            <Accordion  >
                <AccordionSummary>
                    <AttachIcon />
                    <Typography level="body-sm">
                        { pluralize(fileAssociations?.length, 'File') }
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack
                        spacing={1}
                        divider={<Divider />}
                    >
                        {
                            fileAssociations.map((a) => {
                                return (
                                    <FileItem key={a.uuid} association={a} />
                                );
                            })
                        }
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </AccordionGroup>
    );
});

export default CollabWorkSpaceSidebarFiles;
